import React, { ReactNode } from 'react';
import Column from '@amzn/meridian/column';
import LinearGauge from '@amzn/meridian/linear-gauge';
import Text from '@amzn/meridian/text';
import {
  colorBlue500,
  colorSuccess500,
} from '@amzn/meridian-tokens/base/color';

interface LinearGaugeWithSubtitleProps {
  total: number;
  value: number;
  subtitle: ReactNode;
  topSubtitle?: ReactNode;
  height?: number;
  width?: number;
}

export const LinearGaugeWithSubtitle = ({
  total,
  value,
  subtitle,
  topSubtitle,
  width,
}: LinearGaugeWithSubtitleProps) => {
  // When both total and value are 0, we need to adjust them to ensure the gauge renders properly
  // The Meridian LinearGauge component doesn't fill with any color when both values are 0
  // By setting adjustedTotal and adjustedValue to 1 in this case, we ensure a full green bar is shown,
  // without affecting the numbers displayed for coaching required and coaching completed
  const adjustedTotal = total === 0 && value === 0 ? 1 : total;
  const adjustedValue = total === 0 && value === 0 ? 1 : value;

  return (
    <Column spacing='200' spacingInset='none' width={width}>
      {topSubtitle && (
        <Text type='b200' color='secondary'>
          {topSubtitle}
        </Text>
      )}
      <LinearGauge
        type='fill'
        value={adjustedValue}
        target={total !== value ? value : undefined}
        minValue={0}
        maxValue={adjustedTotal}
        fillColor={total <= value ? colorSuccess500 : colorBlue500}
      />
      <Text type='b200' color='secondary'>
        {subtitle}
      </Text>
    </Column>
  );
};

export default LinearGaugeWithSubtitle;
